import React, { useState, useRef, useEffect } from 'react';
import { Validaciones, Encriptar } from '@renedelangel/helpers';
import AccountCircle from '@material-ui/icons/AccountCircle';
import moment from 'moment';
// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

import { BrowserRouter as Router, Switch, Route, useParams, useHistory } from "react-router-dom";
// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';
//storage
import { actualizaArchivo, getArchivo } from "../../../helpers/serverStorage";

// material-ui icons
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import Button from '@material-ui/core/Button';
import Update from '@material-ui/icons/Update';
import SaveIcon from '@material-ui/icons/Save';

import { handleFocus, handleErrorInputText, handleModificar, handleGuardar } from '../../../_layout/helpers/handles';
import { info, danger, success, primary, black } from '../../../_layout/helpers/colores';
import { upsertFile, tablaServerStorage, getFile } from '../../../mutations/ServerStorage'
import { showFile } from '../../../helpers';
import './styles.css';

const { trim } = Validaciones;

function Importar() {

    const { Encrypt, Decrypt } = Encriptar;

    const { token,usuario } = useSelector(state => state.login);

    let remover = false;
    const cleanState = { serverStorageID: null };
    const cleanErrorState = {}
    const cleanNotificaciones = { mensaje: "", color: null, open: false };

    let [state, setState] = useState(cleanState); 
 
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [documento, setDocumento] = useState({ valor: "", file: "", eliminar: remover });

    let titleAccion = state.storageID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} documento`;
    let ArrayRef = [];

    const filtroUbicado = [ 
        { label: 'Todos', value: null },
        { label: 'Ubicado', value: true },
        { label: 'No Ubicado', value: false },
    ];

    const filtroTabla = [ 
        { label: 'Todos', value: null },
        { label: 'Control de Pago', value: 'Control de Pago' },
        { label: 'Fotos de Evidencia', value: 'Fotos de Evidencia' },
        { label: 'Pólizas de Fianza', value: 'Pólizas de Fianza' },
        { label: 'Pólizas de Seguro', value: 'Pólizas de Seguro' },
        { label: 'Reclamaciones a Terceros', value: 'Reclamaciones a Terceros' },
        { label: 'Reclamaciones Aseguradoras', value: 'Reclamaciones Aseguradoras' },
        { label: 'Recorridos', value: 'RECORRIDOS' },
        { label: 'Recorridos Condiciones', value: 'RECORRIDOS CONDICIONES' },
        { label: 'Reporte Accidente Laboral', value: 'Reporte Accidente Laboral' },
        { label: 'Reporte Accidente Laboral 2', value: 'REPORTEACCIDENTELABORAL' },
        { label: 'Reporte de daños', value: 'Reporte de daños' },
        { label: 'Reporte de daños 2', value: 'REPORTEDANIOS' },
        { label: 'Reporte de daños clientes', value: 'Reporte de daños clientes' },
        { label: 'Reporte de daños clientes 2', value: 'REPORTEDANIOSCLIENTES' },
        { label: 'Reporte de daños gerencia', value: 'REPORTEDANIOSGERENCIA' },
        { label: 'Seguimiento Actividades', value: 'Seguimiento Actividades' },
        { label: 'Solicitud de Contenidos', value: 'Solicitud de Contenidos' },
        { label: 'Solicitud Póliza de Equipo de Operación', value: 'Solicitud Póliza de Equipo de Operación' },
        { label: 'Solicitud Póliza de Equipo Electrónico', value: 'Solicitud Póliza de Equipo Electrónico' },
        { label: 'Solicitud Seguro de Autos', value: 'Solicitud Seguro de Autos' },
        { label: 'Solicitud Seguro Fianzas', value: 'Solicitud Seguro Fianzas' },
        { label: 'Solicitud Seguro Gastos Medicos', value: 'Solicitud Seguro Gastos Medicos' },
        { label: 'Solicitud Seguro Transporte de Mercancias', value: 'Solicitud Seguro Transporte de Mercancias' },
        { label: 'Usuarios', value: 'USUARIOS' },
    ];    

    const acciones = [
        {
            icono: Update,
            color: info,
            descripcion: "Sustiuir Adjunto",
            parametros: [{ campo: "serverStorageID" }, { campo: "tabla", variable: "tabla" }, { campo: "tipo", variable: "tipo" }, { campo: "clasificacion", variable: "clasificacion" }, { campo: "origenID", variable: "origenID" }, { campo: "ubicado", variable: "ubicado" }],
            disabled: { multiseleccion: true },
            onClick: (parametros) => handleModificar({
                parametros, token, setState, setOpen, setAlert,
                asyncGet: getFile,formatearResultado:[
                    { id: "fechaInicial", formato: (data) => data && moment(data) },
                    { id: "fechaFinal", formato: (data) => data && moment(data) },
                ]
            })
        }        
    ];

    let botones = [
        {
            icono: SyncIcon,
            color: info,
            descripcion: "Actualizar",
            onClick: () => setActualizar(!actualizar),
            disabled: { multiseleccion: true }
        }
    ];

    const infoTabla = {
        botones,
        acciones,
        actualizar,
        id: "serverStorageID",
        color: primary,
        title: "Importar Adjuntos",
        title2: "",
        iconTable: <AccountCircle />,
        headers: [
            { variable: "tabla", descripcion: "Categoría" },
            { variable: "tipo", descripcion: "Carpeta" },
            { variable: "clasificacion", descripcion: "Subcarpeta" },
            { variable: "nombreArchivo", descripcion: "Nombre" },
            { variable: "ubicado", descripcion: "Ubicado" },
            { variable: "serverStorageID", descripcion: "Archivo" },
            { variable: "ruta", descripcion: "Ruta", hide: true },
        ],
        responsiveTitle: ["tipo", "clasificacion", "nombreArchivo"],
        filter: [
            { campo: "tipo", variable: "tipo", placeholder: "Capture el tipo" },
            { campo: "clasificacion", variable: "clasificacion", placeholder: "Capture la clasificacion" },
            { campo: "nombreArchivo", variable: "nombreArchivo", placeholder: "Capture el nombre" },
        ],
        selectFilter: [
            { campo: "tabla", title: "Categoría", placeholder: "Seleccionar la categoría", limpiarFiltro: "Todos", data: filtroTabla, grid: { md: 3, lg: 3 } }, 
            { campo: "ubicado", title: "Ubicado", placeholder: "Seleccionar la ubicación", limpiarFiltro: "Todos", data: filtroUbicado, grid: { md: 2, lg: 2 } }, 
        ],
        alineacion: [{ columnas: [0], alineacion: "left" }, { columnas: [0, 4, 5, 6, 7], alineacion: "center" }],
        formato: [
            { columnas: ["ubicado"], tipo: "estatus" },
            {
                columnas: ["serverStorageID"], tipo: "custom", callback: (id, data) =>
                    <div className='cAuxButtonDownload'><Button size="small" variant="outlined" color="primary" style={{backgroundColor: 'aliceBlue'}} disabled={!data.ubicado.value} onClick={() => descargarAdjuntos(id)}>{'Descargar'}</Button></div>
            },
        ],
    }

    const inputs = [];
    const InputsConID = [];
    const Secciones = [];

    cleanErrorState["serverStorageID"] = { error: false, helperText: "" };
    cleanState["serverStorageID"] = 0;

    InicializarInputs("tabla", "", "Categoría", "", "", 100);
    InicializarInputs("tipo", "", "Carpeta", "", "", 100);
    InicializarInputs("clasificacion", "", "Subcarpeta", "", "", 100);    

    InicializarInputs("archivo", "", "Archivo", "", "", 100);
    InicializarInputs("nombreDocumento", "Nombre del archivo *", "nombre del archivo", "", "", 100);
    InicializarInputs("extension", "Extensión", "Extensión", "", "", 10);

    InputsConID["tabla"].grid = { md: 4, lg: 4 };
    InputsConID["tipo"].grid = { md: 4, lg: 4 };
    InputsConID["clasificacion"].grid = { md: 4, lg: 4 };

    InputsConID["archivo"].grid = { md: 12, lg: 12 };
    InputsConID["nombreDocumento"].grid = { md: 8, lg: 8 };
    InputsConID["extension"].grid = { md: 4, lg: 4 };
    InputsConID["nombreDocumento"].disabled = state.serverStorageID !==0;
    InputsConID["extension"].disabled = true;

    InputsConID["tabla"].inputProps = { readOnly: true }
    InputsConID["tipo"].inputProps = { readOnly: true }
    InputsConID["clasificacion"].inputProps = { readOnly: true }

    InputsConID["archivo"].inputProps = { type: "file" }
    InputsConID["archivo"].onChange = ({ target: { value, files } }) => handleChangeFiles({ value, files }, "archivo");
    InputsConID["extension"].inputProps = { readOnly: true }
   
    function InicializarInputs(Identificador, pTitulo = "", pPlaceholder = "", ValorInicial = "", Seccion = "", MaxLength = 0) {

        cleanErrorState[Identificador] = { error: false, helperText: "" };
        cleanState[Identificador] = ValorInicial;
        ArrayRef[Identificador] = useRef(null);

        if (pTitulo === "") {
            pTitulo = Identificador;
        }

        if (pPlaceholder === "") {
            pPlaceholder = pTitulo;
        }

        let tInput = {
            value: state[Identificador],
            id: Identificador,
            error: errorState[Identificador].error,
            success: state[Identificador] && !errorState[Identificador].error ? true : undefined,
            helperText: errorState[Identificador].helperText,
            inputRef: ArrayRef[Identificador],
            title: pTitulo,
            placeholder: pPlaceholder,
            onChange: ({ target: { value } }) => handleChange(value, Identificador, MaxLength),
            onKeyDown: () => { return; }
        };

        InputsConID[Identificador] = tInput;
        if (Seccion === "") {
            inputs.push(tInput);
            return;
        }

        let tInputsDeSeccion = [];
        let InputFieldSet;
        if (Secciones[Seccion]) {
            InputFieldSet = Secciones[Seccion];
            tInputsDeSeccion = InputFieldSet.inputs;
        } else {
            InputFieldSet = {
                id: Seccion,
                leyenda: Seccion,
                placeholder: Seccion,
                tipo: "fieldset",
                sizeLetra: "1.05em"
            };

            inputs.push(InputFieldSet);
        }

        tInputsDeSeccion.push(tInput);
        InputFieldSet.inputs = tInputsDeSeccion;
        Secciones[Seccion] = InputFieldSet;
    }

    const accionesFormulario = [{
        loader,
        disabled: false,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: ArrayRef["serverStorageID"],
            mensajeCorrecto: `El documento ${state["nombreArchivo"] ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState, condicion, ref, keyError, mensajeError,
            loader: setLoader, disabled: setDisabled, errorState: setErrorState
        });
    }

    function handleChangeFiles({ files, value }, key) {
        if (files === null) {
            remover = true;
        }

        if (files[0].size > 10000000) {
            setNotificaciones({ mensaje: "El archivo supera el tamaño permitido (10mb)", color: 'danger', open: true })
            return;
        }

        setNotificaciones(cleanNotificaciones)
        setDocumento({ valor: value, file: files[0], eliminar: false });
        let nom = files[0].name;
        let punto = nom.indexOf('.');
        let ext = nom.substring(punto, nom.length);
        let nomDocumento = nom.substring(0, punto);

        setState({
            ...state,
            [key]: value,
            [`${key}File`]: files[0],
            [`${key}Name`]: files[0].name,
            ["nombreDocumento"]: nomDocumento,
            ["extension"]: ext
        });

        setErrorState(errorState => ({
            ...errorState,
            [key]: { helperText: "", error: false }
        }));

    }
    
    const descargarAdjuntos = async function (id) { 

        let archivo = await getFile({ serverStorageID: id }, token);
        let documento = await getArchivo(archivo.ruta, token);

        let inicio = documento.length;
        let cadena = documento.indexOf(',')
        let b64 = documento.substring(cadena + 1, inicio);

        let iniciofor = documento.indexOf(':');
        let finfor = documento.indexOf(';');

        let ext = documento.substring(iniciofor + 1, finfor);

        showFile(b64, archivo.nombreArchivo, ext)

    };

    async function handleValidaciones() {

        let error;
        let id = state.serverStorageID == 0 ? null : state.serverStorageID;
        let validaciones = [
            {
                condicion: !documento.file && id === null,
                ref: ArrayRef["archivo"], keyError: "archivo",
                mensajeError: "Debe seleccionar un archivo"
            },
            {
                condicion: !state["nombreDocumento"] || trim(state["nombreDocumento"]) === "",
                ref: ArrayRef["nombreDocumento"], keyError: "nombreDocumento",
                mensajeError: "Debe especificar el nombre del archivo"
            },
        ];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (error) return;
            error = ftErrorInputText({
                condicion, ref, keyError, mensajeError
            })
        });
        if (error) return error;
    }
    
    function ftGuardar() {
        async function ftGuardar() {
            let error = await handleValidaciones();

            if (error) return error;
            let rutaArchivo = state.tabla + '/' + state.tipo + '/' + state.clasificacion + '/';
            let datos = {
                serverStorageID: state.serverStorageID ? state.serverStorageID : null,
                origenID: Number(state.origenID),
                tipo: state.tipo ? state.tipo : '',
                clasificacion: state.clasificacion ? state.clasificacion : null,
                nombreArchivo: `${state.nombreDocumento}${state.extension}`,
                ruta: state.rutaFile ? state.rutaFile : rutaArchivo,
                tabla: state.tabla ? state.tabla : 'Proyectos',
                usar: state.usar,
                fechaInicial: state.fechaInicial ? `${state.fechaInicial.format("YYYY/MM/DD")}` : null,
                fechaFinal: state.fechaFinal ? `${state.fechaFinal.format("YYYY/MM/DD")}` : null,
                ubicado: true
            }

            if (documento.file === null) {
                await upsertFile({ input: datos }, token);
            } else {
                await actualizaArchivo(rutaArchivo, documento.file, 1, datos, token);
            }

        }
        return ftGuardar();
    };

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setDocumento({ archivo: { valor: "", file: "" } });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key, MaxLength = 0) {
        
        if(key == 'archivo'){
            let { name, files } = value.target;
            let archivos = Array.from(files);
            setState(state => {
                return {
                    ...state,
                    [key]: archivos
                }
            })
            return;
        } else {
            if (value.length > MaxLength && MaxLength !== 0) {
                return;
            }
            setState(state => ({
                ...state,
                [key]: value
            }));

            setErrorState(errorState => ({
                ...errorState,
                [key]: { helperText: "", error: false }
            }));
        }
    };

    return (<>
        <Tabla
            infoTabla={infoTabla}
            asyncData={tablaServerStorage}
            token={token}
            parametrosFijos={{ origenID: null, tabla: null, ubicado: null }}
        />
        <FormularioModal
            open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            acciones={accionesFormulario}
            focus={ArrayRef["clasificacion"]}
        />
        {alert && <SweetAlert
            title={alert.title}
            descripcion={alert.descripcion}
            tipo={alert.tipo}
            msjConfirmacion={alert.msjConfirmacion}
            msjCancelacion={alert.msjCancelacion}
            onConfirm={alert.onConfirm}
            showConfirm={alert.showConfirm}
            showCancel={alert.showCancel}
            onCancel={() => setAlert(null)}
        />}
    </>);
}

export default Importar;
